import stepsConfig from '../stepsConfig';
import { deepTrimStrings, applyDefaults } from '../wizard/utils/formHelpers';
import { applyTripCurrencyToFormData, getTripCurrency } from '../wizard/utils/tripCurrency';
import { applyReturnDatesToDepartures } from '../wizard/utils/tripDates';
import { STEP_PAYLOAD } from '../wizard/stepPayloads';

// UI-only or per-load-volatile keys (signed preview URLs change on every load)
const VOLATILE = new Set(['pendingFile', 'image', 'hero_image', 'package_hero_image']);

const canon = (v) => {
    if (Array.isArray(v)) return v.map(canon);
    if (v && typeof v === 'object') {
        return Object.keys(v).sort().reduce((acc, k) => {
            if (VOLATILE.has(k)) return acc;
            const c = canon(v[k]);
            if (c !== undefined) acc[k] = c;     // '' / null / undefined all count as "empty"
            return acc;
        }, {});
    }
    return v === '' || v === null ? undefined : v;
};

/** The step exactly as it would be sent (trim, currency sync, defaults applied). */
export const buildStepPayload = (stepKey, formData) => {
    let fd = applyTripCurrencyToFormData(deepTrimStrings(formData), getTripCurrency(formData));
    if (stepKey === 'departures') fd = applyReturnDatesToDepartures(fd, fd.packages?.duration);
    const cfg = stepsConfig[stepKey];
    if (cfg?.fields) fd = { ...fd, [stepKey]: applyDefaults(cfg.fields, fd[stepKey]) };
    return STEP_PAYLOAD[stepKey](fd);
};

export const fingerprint = (stepKey, formData) =>
    JSON.stringify(canon(buildStepPayload(stepKey, formData)));